document.addEventListener('DOMContentLoaded', () => {
  /* =========================================================
     1. VIDEO MODAL
     ========================================================= */
  const modal     = document.getElementById('videoModal');
  const frameWrap = document.getElementById('videoFrameWrap');
  const closeBtn  = document.getElementById('closeModal');

  if (modal && frameWrap && closeBtn) {
    document.querySelectorAll(
      '.section-video-thumbs .thumb, .video-thumbnails-section .thumb'
    ).forEach(btn => {
      btn.addEventListener('click', () => {
        frameWrap.innerHTML = `
          <iframe src="${btn.dataset.video}?autoplay=1"
                  allow="autoplay; encrypted-media"
                  frameborder="0"
                  allowfullscreen>
          </iframe>`;
        modal.classList.remove('hidden');
      });
    });

    const closeModal = () => {
      modal.classList.add('hidden');
      frameWrap.innerHTML = '';
    };
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', e => {
      if (e.target === modal) closeModal();
    });
  }

  /* =========================================================
     2. STRIP & ARROWS VISIBILITY
     ========================================================= */
  const strip   = document.querySelector('.video-grid');
  const prevBtn = document.querySelector('.slider-prev');
  const nextBtn = document.querySelector('.slider-next');
  if (!strip || !prevBtn || !nextBtn) return;  // fail-safe

  const toggleArrows = () => {
    const thumbCount = strip.querySelectorAll('.thumb').length;
    const isDesktop  = window.innerWidth >= 1024;
    const canScroll  = strip.scrollWidth > strip.clientWidth;
    const show       = isDesktop ? (thumbCount > 4) : canScroll;
    prevBtn.style.display = nextBtn.style.display = show ? '' : 'none';
  };
  toggleArrows();
  window.addEventListener('resize', toggleArrows);
  strip.addEventListener('scroll', toggleArrows);

  /* =========================================================
     3. CHUNKED SCROLL CONTROLS
     ========================================================= */
  // get the CSS gap between thumbs
  const gapPx = parseInt(getComputedStyle(strip).gap, 10) || 0;

  function getCardScrollAmount() {
    const firstThumb = strip.querySelector('.thumb');
    return firstThumb
      ? firstThumb.offsetWidth + gapPx
      : strip.clientWidth * 0.8;  // fallback
  }

  prevBtn.addEventListener('click', () => {
    strip.scrollBy({
      left: -getCardScrollAmount(),
      behavior: 'smooth'
    });
  });
  nextBtn.addEventListener('click', () => {
    strip.scrollBy({
      left: getCardScrollAmount(),
      behavior: 'smooth'
    });
  });

  /* =========================================================
     4. DESKTOP WHEEL / TRACKPAD HORIZONTAL SCROLL
     ========================================================= */
  strip.addEventListener('wheel', e => {
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      e.preventDefault();
      strip.scrollLeft += e.deltaX;
    }
  }, { passive: false });
});
